import { AuthenticatedApp } from '@room/shared-ui';
import { SettingsPage } from './pages/SettingsPage';

export function App() {
  return (
    <AuthenticatedApp appName="Settings">
      <SettingsPage />
    </AuthenticatedApp>
  );
}
